class RegisterFormPopup extends HTMLElement {
  constructor() {
    super();

    this.classToggle = 'custom-user-login__active';

    // Trigger button to show the popup
    document.querySelectorAll('a[href="#register-popup"]').forEach((link) => {
      link.addEventListener('click', () => {
        this.initPopup();
        document.querySelector('body').classList.add(this.classToggle);
      });
    });


    if (Shopify.designMode) {
      if (Shopify.designMode) {
        window.addEventListener('shopify:block:select', (event) => {
         console.log('shopify:block:select');
         this.initPopup();
        });
      }
    }
  }

  initPopup() {
    this.companyId = window.klaviyoSettings.companyId;
    this.listId = window.klaviyoSettings.listId;

    // Find the elements
    this.section = this.closest('#shopify-section-register-popup');
    this.form = this.querySelector('form');
    this.emailField = this.form.querySelector('[data-custom-registration-field]');
    this.buttonNext = this.form.querySelector('button[type="button"]')
    this.buttonSubmit = this.form.querySelector('button[type="submit"]');

    // Click outside of the register popup
    this.section?.addEventListener('click', (e) => {
      if (!e.target.closest('register-form-popup')) {
        document.querySelector('body').classList.remove(this.classToggle);
        this.form.querySelector('[data-custom-registration-step="1"]').classList.remove('hidden');
        this.form.querySelector('[data-custom-registration-step="2"]').classList.add('hidden');
      }
    });

    // Enable the buttonNext when the email field is valid
    this.emailField.addEventListener('input', () => {
      this.enableButtonNext();
    });

    // when 'Enter' in the email field, trigger a click on the buttonNext
    this.emailField.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        this.buttonNext.click();
      }
    });

    // show the next step
    this.buttonNext.addEventListener('click', async (e) => {
      this.form.querySelector('[data-custom-registration-step="1"]').classList.add('hidden');
      this.form.querySelector('[data-custom-registration-step="2"]').classList.remove('hidden');
      this.form.querySelector('input[name="customer[first_name]"]').focus();
      return false;
    });

    // On form submit, process the registration
    this.form.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      await this.processSubscription();
    });

    setTimeout(() => {
      this.emailField.focus();
      this.enableButtonNext();
    }, 100);
  }

  /**
   * Enable the buttonNext when the email field is valid
   */
  enableButtonNext() {
    if (this.emailField.validity.valid) {
      this.buttonNext.disabled = false;
    } else {
      this.buttonNext.disabled = true;
    }
  }

  /**
   * Process the newsletter subscription
   */
  async processSubscription() {
    this.isLoading(true);

    try {
      // Validate all form fields
      const emailValid = await this.validateField(this.emailField);
      const firstNameField = this.form.querySelector('[name="customer[first_name]"]');
      const lastNameField = this.form.querySelector('[name="customer[last_name]"]');
      const passwordField = this.form.querySelector('[name="customer[password]"]');

      const firstNameValid = await this.validateField(firstNameField);
      const lastNameValid = await this.validateField(lastNameField);
      const passwordValid = await this.validateField(passwordField);

      // If there are errors in the form, throw an error
      if (!emailValid || !firstNameValid || !lastNameValid || !passwordValid) {
        throw new Error('Please fill in all required fields correctly');
      }

      // First, handle Klaviyo subscription
      await this.handleKlaviyoSubscription();

    } catch (err) {
      console.log('I have an error', err);
    } finally {

      // Submit the Shopify form (this will redirect to the return_to URL)
      this.form.submit();

      this.isLoading(false);
    }
  }

  async validateField(field) {
    const { name, value, validity } = field;
    field.setAttribute('aria-invalid', !validity.valid);
    return validity.valid;
  }

  isLoading(loading) {
    this.buttonSubmit.classList.toggle('loading', loading);
  }

  async handleKlaviyoSubscription() {
    // Get additional customer data
    const firstNameField = this.form.querySelector('[name="customer[first_name]"]');
    const lastNameField = this.form.querySelector('[name="customer[last_name]"]');

    // Create the user data
    const userData = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: this.emailField.value,
                first_name: firstNameField?.value || '',
                last_name: lastNameField?.value || '',
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED',
                    },
                  },
                },
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: this.listId,
            },
          },
        },
      },
    };

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2025-01-15',
        'content-type': 'application/vnd.api+json',
        'Access-Control-Allow-Origin': '*',
      },
      body: JSON.stringify(userData),
    };

    console.log('Klaviyo subscription:', options);

    try {
      // If successful, create the client subscription
      await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${this.companyId}`, options).then(
        (res) => {
          if (!res.ok) {
            throw new Error('Failed to create client subscription');
          }
          console.log('Klaviyo subscription successful');
        }
      );
    } catch (error) {
      console.log('Klaviyo subscription error (continuing with Shopify registration):', error);
      // Don't throw error here - let Shopify registration continue even if Klaviyo fails
    }
  }

  /**
   * Toggles the error message.
   * @param {Boolean} show Whether to show the error message.
   * @param {String} message The error message.
   */
  toggleErrorMessage(show, message = '') {
    console.log('The form has an error: ', message);
    const formErrorEl = document.querySelector('.form-error');
    if (formErrorEl) {
      formErrorEl.classList.toggle('hidden', !show);
      formErrorEl.textContent = message;
    }
  }
}

if (!customElements.get('register-form-popup')) {
  customElements.define('register-form-popup', RegisterFormPopup);
}
